import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SplashScreenComponent } from './modules/splash-screen/splash-screen.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from 'src/app/shared/material-module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LayoutModule } from '@angular/cdk/layout';
import { AgmCoreModule } from '@agm/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SnackBarComponent } from './core/components/snack-bar/snack-bar.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { RefreshTokenInterceptor } from 'src/app/core/services/refresh-token.interceptor';
import { TermsAndConditionsListingComponent } from './modules/terms-and-conditions-listing/terms-and-conditions-listing.component';
import { UserProfileComponent } from './modules/user-profile/user-profile.component';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireModule } from '@angular/fire/compat';
import { FirebaseMessagingService } from 'src/app/shared/services/firebase-messaging.service';
import { AsyncPipe } from '../../node_modules/@angular/common';
import { environment } from 'src/environments/environment';
import { PushNotificationService } from 'src/app/shared/services/push-notification.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { AppDownloadComponent } from './modules/app-download/app-download.component';
import { TimeoutApiInterceptor } from './core/services/timeout-api.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { EcdhInterceptor } from './core/services/ecdh.interceptor';
@NgModule({
  declarations: [
    AppComponent,
    SplashScreenComponent,
    SnackBarComponent,
    TermsAndConditionsListingComponent,
    UserProfileComponent,
    AppDownloadComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatBottomSheetModule,
    LayoutModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MaterialModule,
    HttpClientModule,
    NgIdleKeepaliveModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: environment.GM_API_KEY,
      apiVersion: '3.17',
      libraries: ['places', 'drawing', 'geometry']
    }),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    FirebaseMessagingService,
    PushNotificationService,
    AsyncPipe,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
      {
            provide: HTTP_INTERCEPTORS,
            useClass: EcdhInterceptor,
            multi: true
        },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutApiInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
